import { createContext } from 'react'

export const PinOutContext = createContext(
  {} as {
    moveWidget: (move: boolean) => void
    setPinOut: () => void
    onRmvPlaceHolder: (arg: boolean) => void
  }
)
